export const PRINT_TEXT = {
  stl: "STL",
  companyName: "Ye Yint Company Ltd",
  documentTitle: "Goods Issued & Delivery Note",
  issuedBy: "Issued By",
  deliveredBy: "Delivered By",
  receivedBy: "Received By",
  tableHeaders: [
    "No",
    "Ro No",
    "Item Code",
    "Item Description",
    "Packing Type",
    "Unit",
    "Qty",
    "Remark",
  ],
  receivedCondition: "Above items are received in good condition.",
  receivedConditionBurmese: "အထက်ပါကုန်ပစ္စည်းများကို ကောင်းမွန်မှန်ကန်တိကျစွာ လက်ခံရရှိပါသည်။",
  sign: "Sign",
  name: "Name",
  position: "Position",

  authorized: "AUTHORIZED BY",
  total_amount: "TOTAL AMOUNT",
  transport_charge: "TRANSPORT CHARGES",
  sale_tax: "SALES TAX",
  less_deposit: "LESS DEPOSIT",
  balance: "BALANCE DUE",
  memo: "MEMO: Consignment Sale",
  slae_invoice_note:
    "Note : Please make sure receiving Official Cash Receipt after each payment",
  invoice_voucher_text_one: "YANGON Tel:01-2585340,01-3585340,0973254727",
  invoice_voucher_text_two:
    "Mandalay Branch Tel:02-5155020-21,09940885406,NayPyiTaw Branch Tel:067-432397,09952877173",
  invoice_voucher_text_three:
    "Lashio Branch Tel:09977753661, Mawlamyine Branch Tel:09-73790955,09952877172",
};
